<template>
  <router-view></router-view>
</template>

<script type="text/javascript" src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
<script type="text/javascript" src="js/wow.min.js"></script>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @import './assets/css/style.css';
  @import './assets/css/reset.css';
</style>



// WEBPACK FOOTER //
// src/App.vue